import styled from "styled-components";

export const BackgroundFeedPageImageContainer = styled.div`
  position: sticky;
  top: 5rem;

  aspect-ratio: 16/9;

  max-height: 1080px;
  width: 100%;

  @media (max-width: 990px) {
    top: 1rem;
  }

  img {
    object-fit: cover;

    border: none;
  }

  .gradient-background {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${({ theme }) =>
      theme.mode === "dark"
        ? "linear-gradient(0deg, #000000, rgba(0, 0, 0, 0.8)), linear-gradient(180.65deg, rgba(11, 10, 13, 0) 50.61%, #0b0a0d 65.1%)"
        : "linear-gradient(0deg, rgba(246, 246, 252, 0.8), rgba(246, 246, 252, 0.8)), linear-gradient(180.65deg, rgba(246, 246, 252, 0) 50.61%, #F6F6FC 65.1%)"};

    transition: 0.3s all;
  }
`;
